// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"forward"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M12 12L6.75 17.25V6.75L12 12Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M19 12L13.75 17.25V6.75L19 12Z"}}]},{"tag":"g","attrs":{"id":"stroke1"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M12 12L6.75 17.25V6.75L12 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor1","d":"M19 12L13.75 17.25V6.75L19 12Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const ForwardIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'forward',
    ref,
    icon: element,
  },
));

ForwardIcon.displayName = 'ForwardIcon';

export default ForwardIcon;
